const grey500Color = '#C2C8CB';

export default grey500Color;
